import { useState } from "react"
import { ButtonBase, Popover, Stack, Tooltip } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { UserAccessOverflowRow } from "./user-access-overflow-row"

export function UserAccessOverflow({ surplus, users = [], width = 24, height = 24, fontSize = "12px" }) {
    const [anchor, setAnchor] = useState(null)

    return (
        <>
            <Tooltip title="View people with access">
                <ButtonBase
                    onClick={open}
                    onKeyDown={handleKeyDown}
                    aria-haspopup="dialog"
                    aria-label="Show all people with access"
                    data-cy="user-access-overflow"
                    sx={{
                        width,
                        height,
                        ml: "-8px",
                        borderRadius: "50%",
                        border: (theme) => `2px solid ${theme.palette.background.paper}`,
                        bgcolor: "primary.light",
                        color: "text.primary",
                        fontSize,
                        fontWeight: 500,
                        "&.Mui-focusVisible": {
                            backgroundColor: "action.focus",
                            outline: "2px solid",
                            outlineColor: "primary.main",
                            outlineOffset: 2,
                        },
                    }}
                >
                    +{surplus}
                </ButtonBase>
            </Tooltip>
            <Popover
                open={!!anchor}
                anchorEl={anchor}
                onClose={close}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Stack sx={{ p: 1, gap: 0.5, minWidth: 180 }} onClick={stop} data-cy="user-access-overflow-list">
                    <Repeat list={users} keyFn="id" item={<UserAccessOverflowRow />} />
                </Stack>
            </Popover>
        </>
    )

    function open(e) {
        e.stopPropagation()
        setAnchor(e.currentTarget)
    }

    function handleKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            e.stopPropagation()
            setAnchor(e.currentTarget)
        }
    }

    function close(e) {
        e?.stopPropagation?.()
        setAnchor(null)
    }

    function stop(e) {
        e.stopPropagation()
    }
}
